import { Component, OnInit, ChangeDetectorRef, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-terms-conditions",
  templateUrl: "./terms-conditions.component.html",
  styleUrls: ["./terms-conditions.component.css"],
})
export class TermsConditionsComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;

  constructor(
    private activeModal: NgbActiveModal,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() { }

  public decline() {
    this.activeModal.close(false);
  }

  public accept() {
    this.activeModal.close(true);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }

  returnLink() {
    // const ip = window.location.hostname;
    // const protocol = window.location.protocol;
    // if (window.location.hostname == "localhost" || window.location.hostname == "oliveportraits.co.uk") {
    let url = environment.extra_url + "/#/WebPanel/term-and-condition";
    return url;
    // }
    // let url = protocol + "/olive/frontend/#/WebPanel/term-and-condition";
    // return url;
  }
}
